<template>
  <div class="c-modal-black-user">
    <b-modal
      @hidden="$emit('close')"
      size="lg"
      title="بلاک کردن کاربر"
      :hide-footer="true"
      :id="id">
      <template v-if="user.loading">
        <BaseLoading/>
      </template>
      <template v-else>
        <div class="row">
          <div class="col-12 mb-5">

            <b-form-checkbox
              :disabled="user.ban.loading || !checkAccessAdmin"
              v-model="user.ban.status"
              @change="toggleUserBan($event)"
              switch size="lg">
              بلاک کردن کاربر
              (تمام فعالیت های کاربر)
              <b-icon
                v-if="user.ban.loading"
                icon="circle-fill"
                animation="throb"
                font-scale="1"
              />
            </b-form-checkbox>

          </div>

          <div class="col-md-12 mb-3">
            <hr/>
          </div>

          <div class="col-md-12">
            <p>
              بلاک کردن بخش های محتلف برای کاربر :
            </p>
          </div>

          <div
            v-for="(item,i) in user.actions.items"
            :key="i"
            class="col-12 mb-4">
            <div class=" d-flex align-items-center justify-content-between">
              <b-form-checkbox
                :disabled="!checkAccessAdmin"
                v-model="item.status"
                @change="showUpdateModalBanSection($event,item)"
                switch size="lg">
                {{ item.name }}
              </b-form-checkbox>
              <b-button v-if="item.history.length" v-b-toggle="['collapse-'+i]" variant="primary" size="sm">
                نمایش تاریخچه
              </b-button>
            </div>
            <b-collapse :id="'collapse-'+i" class="mt-2">
              <b-card v-for="(history,k) in item.history"
                      :key="k"
              >
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-2">
                      <b>
                        تاریخ مسدود شدن :
                      </b>
                      <span>
                    {{ history.banTime }}
                </span>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="mb-2">
                      <b>
                        علت مسدود شدن :
                      </b>
                      <span>
                    {{ history.banDetail }}
                </span>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="mb-2">
                      <b>
                        تاریخ رفع مسدودیت :
                      </b>
                      <span>
                    {{ history.unbanTime }}
                </span>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="mb-2">
                      <b>
                        علت رفع مسدودیت :
                      </b>
                      <span>
                    {{ history.unbanDetail }}
                </span>
                    </div>
                  </div>
                </div>


              </b-card>
            </b-collapse>
            <div class="my-3">
              <hr>
            </div>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal
      centered
      @hidden="updateModal.onClose"
      size="md"
      :title="updateModal.title"
      :hide-footer="true"
      id="update-modal">
      <div class="row">

        <b-form-textarea
          v-model="updateModal.description"
          :placeholder="!updateModal.status ? 'علت رفع مسدودیت را وارد کنید' : 'علت مسدودیت را وارد کنید.'"
        />

        <div class="d-flex align-items-center justify-content-between w-100 mt-5">
          <b-button
            type="button"
            @click="$bvModal.hide('update-modal')"
          >
            لغو
          </b-button>

          <base-button
            @click="toggleUserBanSection"
            type="success"
            :loading="updateModal.loading"
            :disabled="!updateModal.description"
          >
            تایید
          </base-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {
  banUserAccount,
  banUserSection,
  fetchUserBanedSections,
  unBanUserAccount,
  unBanUserSection
} from "@/httpservices/UserBlock";
import Swal from "sweetalert2";
import moment from "jalali-moment";
import BaseLoading from "@/components/BaseLoading";
import _ from "lodash";
import store from '@/store'

export default {

  name: "ModalUserBlack",
  
  components: {BaseLoading},

  props: {
    userStatus: {
      type: String,
      default: 'Active'
    }
  },

  data() {
    return {
      id: 'user-black-modal',
      user: {
        loading: true,
        ban: {
          loading: false,
          status: false,
        },
        actions: {
          items: [
            {
              name: "واریز تومان",
              value: "FiatDeposit",
              status: false,
              history: [],
            },
            {
              name: "برداشت تومان",
              value: "FiatWithdrawal",
              status: false,
              history: [],
            },
            {
              name: "واریز رمزارز",
              value: "CryptoDeposit",
              status: false,
              history: [],
            },
            {
              name: "برداشت رمزارز",
              value: "CryptoWithdrawal",
              status: false,
              history: [],
            },
            {
              name: "تبدیل",
              value: "Swap",
              status: false,
              history: [],
            },
            {
              name: "پرفکت مانی",
              value: "PerfectMoney",
              status: false,
              history: [],
            },
          ],
        },
      },
      updateModal: {
        sectionName: "",
        status: false,
        loading: false,
        title: "",
        description: "",
        onClose: () => {
        }
      }

    }
  },

  mounted() {
    this.$nextTick(() => {
      this.$bvModal.show(this.id);
      this.user.ban.status = Boolean(this.userStatus === 'Suspend');
      this.getUserBanedSectionHistory();
    });
  },

  methods: {

    getUserId() {
      return this.$route.params.id
    },

    async getUserBanedSectionHistory() {
      this.user.loading = true;
      try {
        const res = (await fetchUserBanedSections(this.getUserId())).data || [];
        const sectionHistories = Object.entries(_.groupBy(res, 'section'));
        this.user.actions.items = this.user.actions.items.map(item => {
          const actionHistory = ((sectionHistories.find(i => item.value === i[0]) || [])[1] || []).reverse();
          const lastUpdated = actionHistory[0] || {};
          return {
            ...item,
            status: Boolean(lastUpdated.section && (!lastUpdated.unbanTime || moment(lastUpdated.unbanTime).isAfter(moment()))), // status:true => Baned
            history: actionHistory.map(data => {
              return {
                banDetail: data.banDetail,
                banTime: data.banTime && moment.utc(data.banTime).local().locale('fa').format('jYYYY-jMM-jDD ساعت H:m'),
                unbanDetail: data.unbanDetail,
                unbanTime: data.unbanTime && moment.utc(data.unbanTime).local().locale('fa').format('jYYYY-jMM-jDD ساعت H:m'),
              }
            })
          }
        })
      } catch (e) {
        console.log(e)
      }
      this.user.loading = false;
    },

    async toggleUserBan(status) {
      const text = status
        ? "آیا از مسدود کردن کاربر مطمئن هستید ؟ "
        : "آیا از آزاد کردن کاربر مطمئن هستید ؟";
      const {isConfirmed} = await Swal.fire({
        title: "توجه",
        html: text,
        confirmButtonText: "بله",
        cancelButtonText: `خیر`,
        showCancelButton: true
      });
      if (!isConfirmed) {
        this.user.ban.status = !this.user.ban.status;
        return
      }
      this.user.ban.loading = true;
      try {
        const userBanAction = this.user.ban.status
          ? banUserAccount
          : unBanUserAccount;

        await userBanAction(this.getUserId());

        const title = this.user.ban.status
          ? 'کاربر به طور کامل مسدود شد.'
          : 'کاربر از حالت مسدود خارج شد.';

        await Swal.fire({
          title,
          icon: "success",
          confirmButtonText: "باشه"
        });

        this.$emit('updateUser')

      } catch (e) {
        console.log({e})
      }
      this.user.ban.loading = false;
    },

    showUpdateModalBanSection(status, section) {
      this.updateModal = {
        ...this.updateModal,
        status,
        sectionName: section.value,
        loading: false,
        title: status
          ? `آیا از مسدود کردن بخش ${section.name} برای کاربر مطمئن هستید ؟ `
          : `آیا از آزاد کردن بخش ${section.name} برای کاربر مطمئن هستید ؟ `,
        description: "",
        onClose: () => {
          section.status = !section.status;
          this.$bvModal.hide('update-modal');
        }
      }
      this.$bvModal.show('update-modal');
    },

    async toggleUserBanSection() {
      this.updateModal.loading = true;
      try {
        const resolver =
          Boolean(!this.updateModal.status)
            ? unBanUserSection
            : banUserSection

        await resolver(this.$route.params.id, {
          "section": this.updateModal.sectionName,
          "detail": this.updateModal.description,
        })

        await this.getUserBanedSectionHistory();
        await Swal.fire({
          title: "با موفقیت انجام شد.",
          icon: "success",
          confirmButtonText: "باشه"
        });

      } catch (e) {
        console.log('error')
        console.log(e)
      }
      this.updateModal.loading = false;
      this.updateModal = {
        ...this.updateModal,
        sectionName: "",
        status: false,
        loading: false,
        title: "",
        description: "",
        onClose: () => {
        }
      }
      this.$bvModal.hide('update-modal');
    }
  },

  computed: {
    checkAccessAdmin() {
      return Boolean(
        store.getters['isSuperAdmin'] ||
        store.getters['isManagerAdmin'] ||
        store.getters['isApprovingManager']
      );
    }
  },

  watch: {
    userStatus(value) {
      this.user.ban.status = Boolean(value === 'Suspend');
    }
  }

}
</script>

<style scoped>

</style>
